/**
 * @generated SignedSource<<3fb15a58edf864426aa7a79cb40d807f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveITPBanksList_charge$data = {
  readonly companyBankAccount: {
    readonly itpCode: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "PaymentActiveITPBanksList_charge";
};
export type PaymentActiveITPBanksList_charge$key = {
  readonly " $data"?: PaymentActiveITPBanksList_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveITPBanksList_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveITPBanksList_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyBankAccount",
      "kind": "LinkedField",
      "name": "companyBankAccount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "itpCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "44b2f83258cca10d5f93d90074b79fd2";

export default node;
